import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { DatePicker } from 'antd';
import { getTaskFieldMetadata } from './constants';
import { AutoSaverFormItem } from './AutoSaverFormItem';
import { useTask } from './Provider';
import { StageTaskType } from '@/store/Lifecycle/constants';
import { computeValidateStatus, formatDateRangeToUTC, parseDateRangeFromUTC } from './utils';

export const DateRangeField = observer(() => {
  const { t } = useTranslation();
  const task = useTask<StageTaskType.DateRange>();
  const { name, value, validateStatus, help, isSaving, isReadOnly, required } = getTaskFieldMetadata(task);

  const [startDate, endDate] = parseDateRangeFromUTC(value);

  const computedValidateStatus = computeValidateStatus(value, validateStatus);

  return (
    <AutoSaverFormItem
      name={name}
      initialValue={[startDate, endDate]}
      className="stage-task-input-field"
      hasFeedback
      validateStatus={computedValidateStatus}
      help={t(help)}
      required={required}
      getValueFromEvent={formatDateRangeToUTC}
      normalize={parseDateRangeFromUTC}
      saveOnChange
    >
      <DatePicker.RangePicker
        className="stage-task-input"
        placeholder={[t('Start date'), t('End date')]}
        disabled={isReadOnly || isSaving}
        allowEmpty={isReadOnly}
        size="large"
      />
    </AutoSaverFormItem>
  );
});
